import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  userActions,
  permissionActions,
  inventoryActions,
  notificationActions,
  chatActions,
} from '../_actions';
import InventoryAlertModal from '../common/InventoryAlertModal';
import { authHeader, config } from '../_helpers';
import Modal from 'react-responsive-modal';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { toast } from 'react-toastify';
import { AlertPopup } from '../_components/AlertPopup';
import ReactModal from 'react-modal';
import NewModal from 'react-responsive-modal';
import NumberFormat from 'react-number-format';
import { UserDocsList } from './UserDocsList';
import { docsService } from '../_services/docs.service';
import ChangePassword from 'ChangePassword';
import { dateTimeConstants, profileType, userConstants } from '_constants';
import ErrorBoundary from '_components/ErrorBoundary';
import UpdateEmployeeTraining from 'EmployeeTraining';
import UserQualifications from 'UserQualifications';
import Management from 'Settings/Management';
import ApplicantsTab from 'ApplicantTab';
import { profileService } from '_services/profile.service';
import { handleErrorResponse } from '_helpers/helpers';
import { formatDate } from '_helpers/helpers';
import ViewProfile from '_components/Profile/ViewProfile';
import SmsNotification from 'SmsNotification/SmsNotification';
import PropTypes from 'prop-types';
import { ApplicationHistory } from 'Applicants/ApplicationHistory';
import {
  ProfileHeader,
  TabNavigation,
  TabContent,
} from '../common/Profile';

ReactModal.setAppElement('#app');

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hash: this.props.props,
      request_rehire_doc: false,
      request_rehire_doc_status: false,
      tab: this.props.match.params.step,
      statusOpen: false,
      removeOpen: false,
      archiveStep: '3a',
      alertOpen: false,
      mailSendOpen: false,
      doc_request: '',
      requireDocs: false, // for status modal
      email: true,
      sms: true,
      status: '',
      available: '',
      statusStep: '1',
      returnDateField: moment(),
      returnDate: '',
      message: '',
      notes: '',
      alertPop: false,
      userName: '',
      afterSuccess: false,
      inventoryUserAlert: false,
      isGuest: false,
      unavailableReason: 0,
      reasonToDisplay: 0,
      unavailableErr: '',
      unavailableDescriptionErr: '',
      otherReason: '',
      displayOtherReason: '',
      savingNote: false,
      sendingDDForm: false,
      send_dd_form_confirm: false,
      active: 1,
      lastDayWorked: moment(),
      lastDayReason: '',
      lastDayReasonErr: '',
      reloadKey: 0,
      loader: false,
    };
    this.goBack = this.goBack.bind(this);
    this.statusOpenModal = this.statusOpenModal.bind(this);
    this.statusCloseModal = this.statusCloseModal.bind(this);
    this.handleRemoveEmployee = this.handleRemoveEmployee.bind(this);
    this.handleLockProfile = this.handleLockProfile.bind(this);
    this.removeCloseModal = this.removeCloseModal.bind(this);
    this.alertOpenModal = this.alertOpenModal.bind(this);
    this.alertCloseModal = this.alertCloseModal.bind(this);
    this.mailSendOpenModal = this.mailSendOpenModal.bind(this);
    this.mailSendCloseModal = this.mailSendCloseModal.bind(this);
    this.setStatusReturn = this.setStatusReturn.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.collectLastDayWorked = this.collectLastDayWorked.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.editProfile = this.editProfile.bind(this);
    this.updateNotes = this.updateNotes.bind(this);
    this.onImageError = this.onImageError.bind(this);
    this.getEmployeePhotoUrl = this.getEmployeePhotoUrl.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.downloadAllDocuments = this.downloadAllDocuments.bind(this);
    this.downloadAllDocumentsAsPDF = this.downloadAllDocumentsAsPDF.bind(this);
    this.unlockProfile = this.unlockProfile.bind(this);
    this.requireDocs = this.requireDocs.bind(this);
    this.lockProfile = this.lockProfile.bind(this);
    this.remove = this.remove.bind(this);
    this.docRequestModalClose = this.docRequestModalClose.bind(this);
    this.viewHistory = this.viewHistory.bind(this);
    this.viewDetails = this.viewDetails.bind(this);
  }

  collectLastDayWorked() {
    this.setState({ archiveStep: '3b' });
  }

  viewHistory(hash, applnType = '') {
    this.setState(
      { tab: 'ApplicationHistory', hash: hash, applnType },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  viewDetails(hash, applnType = '') {
    this.setState(
      { step: 'ViewApplicant', hash: hash, applnType },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  statusOpenModal() {
    this.setState({ statusOpen: true, statusStep: '1' });
  }

  statusCloseModal() {
    this.setState({
      statusOpen: false,
      unavailableReason: 0,
      unavailableErr: '',
      unavailableDescriptionErr: '',
      otherReason: '',
    });
    // Below changes is to remove the auto added inline styles.
    let doc = document.querySelector('html');
    doc.style.overflow = '';
    doc.style.position = '';
    doc.style.width = '';
    doc.style.top = '';
  }

  removeCloseModal() {
    this.setState({ removeOpen: false, archiveStep: '3a' });
  }

  changeStepParam = (newStep) => {
    const { history, match } = this.props;
    const { hash } = match.params;

    history.replace(`/resource-profile/${hash}/${newStep}`);
  };

  alertOpenModal() {
    this.setState({ alertOpen: true });
  }

  alertCloseModal() {
    this.setState({ alertOpen: false, redirect: '/resources' }, () => {
      this?.props.dispatch({
        type: userConstants?.REMOVEPROFILE_SUCCESS,
        removeUser: null,
      });
    });
  }

  mailSendOpenModal() {
    this.setState({ mailSendOpen: true });
  }

  mailSendCloseModal() {
    this.setState({ mailSendOpen: false });
  }

  handleRemoveEmployee(e) {
    let inventoryList = this.props.inventory.inventory.data || [];
    if (inventoryList?.length) {
      this.setState({ inventoryUserAlert: true, inventoryAlertAction: 'remove', statusOpen: false });
    } else {
      this.setState({ removeOpen: true });
    }
  }

  handleLockProfile(e) {
    let inventoryList = this.props.inventory.inventory.data || [];
    if (inventoryList?.length) {
      this.setState({ inventoryUserAlert: true, inventoryAlertAction: 'lock', statusOpen: false });
    } else {
      this.setStep('1b');
    }
  }

  handleChange(event) {
    if (event.target.name === 'notes') {
      if (this.state.permList.includes('Employee Notes')) {
        this.setState({
          [event.target.name]: event.target.value,
          template: 'custommail',
        });
      }
      return;
    }
    this.setState({
      [event.target.name]: event.target.value,
      template: 'custommail',
    });
  }

  closeAlert() {
    this.setState({
      alertPop: false,
    });
  }

  changeTab(tab) {
    this.changeStepParam(tab);
    this.setState({ tab });
  }

  documentRequest(hash, doc_request) {
    this.setState({ doc_request });
    docsService.requestToFillDocs(hash, doc_request).then(
      (res) => {
        this.setState({
          request_rehire_doc_status: res.success,
          request_rehire_doc: true,
        });
        var hash = '?hash=' + this.state.hash;
        this.props.dispatch(userActions.getProfile(hash));
      },
      (err) => console.log(err),
    );
  }

  openDdformConfirmModal() {
    this.setState({ send_dd_form_confirm: true });
  }

  ddFormConfirmCloseModal() {
    this.setState({
      send_dd_form_confirm: false,
    });
  }

  sendDDForm() {
    if (this.props.user.items.data.hash) {
      this.setState({
        ...this.state,
        sendingDDForm: true,
        send_dd_form_confirm: false,
      });
      let data = new FormData();
      data.append('user_hash', this.props.user.items.data.hash);
      profileService
        .sendDDForm(data)
        .then((res) => {
          if (res.success) {
            toast.success(res.message);
          } else {
            handleErrorResponse(res);
          }
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        })
        .catch((error) => {
          toast.error('Failed to send email to user.');
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        });
    } else {
      toast.error('An unexpected error occurred.');
    }
  }

  docRequestModalClose() {
    this.setState({ request_rehire_doc: false });
  }

  downloadAllDocuments(event, rehire = false, giss = false) {
    let { hash } = this.state.profile;
    let params = {
      uid: this.props.user.profile.data.hash,
      signature: this.props.chat.settings.signature,
    };
    let url = new URL(`${config.apiUrl}/docs/download/${hash}`);
    rehire &&
      (url = new URL(`${config.apiUrl}/docs/download/${hash}?rehire=true`));
    giss && (url = new URL(`${config.apiUrl}/docs/download/${hash}?giss=true`));
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key]),
    );
    window.open(url.href);
  }

  downloadAllDocumentsAsPDF(event, rehire = false, giss = false) {
    let { hash } = this.state.profile;
    let params = {
      uid: this.props.user.profile.data.hash,
      signature: this.props.chat.settings.signature,
    };
    let url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}`);
    rehire &&
      (url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}?rehire=true`));
    giss &&
      (url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}?giss=true`));

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key]),
    );
    window.open(url.href);
  }

  componentDidMount() {
    var hash = '?hash=' + this.state.hash;
    this.props.dispatch(userActions.getProfile(hash));
    this.props.dispatch(permissionActions.getPermission());
    let data = new FormData();
    data.append('hash', this.state.hash);
    this.props.dispatch(inventoryActions.getInventoryList(data));
    this.props.dispatch(chatActions.getConversationSettings());
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props;

    if (user?.lockProfileSuccess && !prevProps.user?.lockProfileSuccess) {
      this.statusCloseModal();
      toast.success('Profile updated successfully');
      this.setState({
        reloadKey: this.state.reloadKey + 1,
        lastDayReason: '',
        lastDayWorked: moment(),
        loader: false,
      });
    }

    if (user?.lockProfileFailure && !prevProps.user?.lockProfileFailure) {
      this.statusCloseModal();
      toast.error('Failed to update profile');
      this.setState({ loader: false });
    }

    if (user?.changeStatusSuccess && !prevProps.user?.changeStatusSuccess) {
      this.statusCloseModal();
      this.setState({ reloadKey: this.state.reloadKey + 1, loader: false });
    }

    if (user?.changeStatusFailure && !prevProps.user?.changeStatusFailure) {
      this.statusCloseModal();
      this.setState({ loader: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { user, inventory, permission } = nextProps;
    var permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;

      this.setState({
        permList,
      });
    }

    var generalQualificationList = [],
      inventory_list = [];
    if (inventory.inventory) {
      if (inventory.inventory.data) {
        var total_cost = 0;
        inventory.inventory.data.map((item, index) => {
          total_cost += parseInt(item.cost, 10);
          inventory_list.push(
            <div className='inv_item' key={index}>
              <div className='inv_cell'>
                {index + 1 + '. ' + item.unique_id + ' (' + item.type + ') '}

                <NumberFormat
                  className='cost'
                  value={item.cost}
                  displayType={'text'}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  thousandSeparator={true}
                  prefix={'$'}
                />
              </div>
            </div>,
          );
          return inventory_list;
        });
        this.setState({ inventory_list, total_cost });
      }
    }

    if (user.items) {
      var profile = user.items.data;
      var available = profile.active === 'Available' ? true : false;
      if (this.props.props == profile.hash) {
        this.setState({
          active: profile.active,
          status: profile.active,
          is_locked: profile.is_locked,
          available: available,
          notes: this?.state?.notes ? this?.state?.notes : profile.notes,
          profile,
          hash: profile.hash,
          userName: profile.first_name,
          user_type: user.items.data.user_type,
          resource_id: user.items.data.crew_identifier_id,
          isGuest: user.items.data.status === 3 ? true : false,
          reasonToDisplay: user.items.data.unavailable_reason,
          displayOtherReason: user.items.data.other_reason,
        });
        if (profile.qualification) {
          profile.qualification.map((item, index) => {
            generalQualificationList.push(
              <p className='crew-profile-detail' key={index}>
                {item}
              </p>,
            );
            return generalQualificationList;
          });
        }
      }
    }

    this.setState({
      generalQualificationList,
      permList,
    });

    if (user.removeUser) {
      if (user.removeUser.success) {
        this.setState({
          alertHead: 'Success',
          alertMsg: user.removeUser.message,
          removeOpen: false,
          archiveStep: '3a',
          alertOpen: true,
        });
      } else {
        var hash = '?hash=' + this.state.hash;
        this.setState({
          alertPop: true,
          alertHead: 'Error',
          alertMsg: user.removeUser.message,
          alertFunction: '',
          archiveStep: '3a',
          removeOpen: false,
        });
      }
    }
    if (user.notes) {
      if (user.notes.success) {
      } else {
        this.setState({
          alertPop: true,
          alertHead: 'Error',
          alertMsg: user.notes.message,
          alertFunction: '',
        });
      }
      this.props.dispatch(userActions.getProfile('?hash=' + this.state.hash));
    }
  }

  //Change the reason for unavailability
  changeUnavailabilityReason = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      unavailableDescriptionErr: '',
      unavailableErr: '',
    });
    e.target.setAttribute('errors', '');
  };

  changeLastDayReason = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      lastDayReasonErr: '',
    });
  };

  setStatusReturn(status) {
    if (Number(this.state.unavailableReason) === Number(0)) {
      this.setState({
        unavailableErr: 'error',
      });
      return;
    }
    if (!this.state.otherReason.trim()) {
      this.setState({
        unavailableDescriptionErr: 'error',
      });
      return;
    }

    if (status) {
      var step = '2a';
      this.setState({
        returnDate: moment().format(dateTimeConstants.DATE_FORMAT),
      });
    } else {
      step = '2b';
      this.setState({
        returnDate: '',
      });
    }
    this.setState(
      {
        statusStep: step,
      },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  setStep(step) {
    this.setState({ statusStep: step }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  updateNotes(hash) {
    let data = new FormData();
    data.append('hash', hash);
    data.append('note', this.state.notes);
    if (this.state.notes !== null) {
      this.setState({ savingNote: true });
      this.props
        .dispatch(userActions.updateEmployeeNote(data, '?hash=' + hash))
        .then(
          (res) => {
            toast.success('Notes Saved !');
            this.setState({ savingNote: false });
          },
          (err) => {
            toast.error('Notes Cannot be saved');
            this.setState({ savingNote: false });
          },
        );
    }
  }

  handleDateChange(date) {
    this.setState({
      returnDateField: date,
      returnDate: date.format('MM/DD/YY'),
    });
  }

  handleLastDayChange(date) {
    if (date) {
      this.setState({
        lastDayWorked: date,
      });
    }
  }

  changeStatus(status) {
    if (status) {
      var stat =
        this.state.status === 'Available' ? 'Unavailable' : 'Available';
      var hash = '?hash=' + this.state.hash;
      let data = new FormData();
      data.append('end_date', this.state.returnDate);
      data.append('hash', this.state.hash);
      data.append('status', stat);
      data.append(
        'unavailableReason',
        this.state.unavailableReason ? this.state.unavailableReason : 0,
      );

      data.append(
        'otherReason',
        this.state.otherReason ? this.state.otherReason : '',
      );

      this.props.dispatch(userActions.changeStatus(data, hash));
      this.props.dispatch(notificationActions.getCount());
      this.setState({ status: stat, active: stat, loader: true });
    }
  }

  lockProfile() {
    if (!this.state || !this.state.lastDayReason || !this.state.lastDayReason.trim()) {
      this.setState({
        lastDayReasonErr: 'error',
      });
      return;
    }
    var stat = 'Locked';
    var hash = '?hash=' + this.state.hash;
    let data = new FormData();

    data.append('hash', this.state.hash);
    data.append('status', stat);
    data.append(
      'last_day_worked',
      moment(this.state.lastDayWorked).format(
        dateTimeConstants.ISO_DATE_FORMAT,
      ),
    );
    data.append('modify_active_status', true);
    data.append('last_day_reason', this.state.lastDayReason);
    this.props.dispatch(userActions.lockUserToggle(data, hash));
    this.props.dispatch(notificationActions.getCount());
    this.setState({ status: stat, loader: true });
  }

  requireDocs(e) {
    this.setState({ requireDocs: e.target.checked });
  }

  unlockProfile() {
    if (!this.state) {
      console.error('Component state is not initialized');
      return;
    }
    var stat = 'Unlocked';
    var hash = '?hash=' + this.state.hash;
    let data = new FormData();
    data.append('hash', this.state.hash);
    data.append('status', stat);
    data.append('document', this.state.requireDocs);
    data.append('modify_active_status', true);
    this.props.dispatch(userActions.lockUserToggle(data, hash));
    this.props.dispatch(notificationActions.getCount());
    this.setState({ status: stat, loader: true });
  }

  remove() {
    if (!this.state || !this.state.lastDayReason || !this.state.lastDayReason.trim()) {
      this.setState({
        lastDayReasonErr: 'error',
      });
      return;
    }
    let data = new FormData();
    this.statusCloseModal();
    data.append('hash', this.state.hash);
    data.append(
      'last_day_worked',
      moment(this.state.lastDayWorked).format(
        dateTimeConstants.ISO_DATE_FORMAT,
      ),
    );
    data.append('last_day_reason', this.state.lastDayReason);
    this.props.dispatch(userActions.removeEmployee(data));
  }

  goBack() {
    this.props.goBack(this.props.resourceDetails);
  }

  toResourceList() {
    this.props.toResourceList();
  }

  editProfile(hash) {
    this.props.editProfile(hash);
  }

  print() {
    window.print();
  }

  sendMail(hash) {
    let data = new FormData();
    this.mailSendCloseModal();
    data.append('type', 'mail');
    data.append('message', this.state.message);
    data.append('user_hash', hash);
    var self = this;
    fetch(config.apiUrl + '/api/employee/sendmails', {
      headers: authHeader(),
      method: 'POST',
      body: data,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          self.setState({
            alertPop: true,
            alertHead: 'Success',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        }
      });
  }

  // Helper method to get employee profile photo URL - uses asset URL + brand name for no_avatar
  getEmployeePhotoUrl(profilePhoto) {
    if (profilePhoto && profilePhoto.trim() !== '') {
      // For uploaded profile photos, use as-is from backend (no replacement)
      return profilePhoto;
    } else {
      // For no_avatar fallback, use asset URL + brand name
      const assetUrl = config.assetUrl;
      const assetBrandName = config.assetBrandName;
      if (assetUrl && assetBrandName && assetUrl.trim() !== '' && assetBrandName.trim() !== '') {
        return assetUrl.trim() + assetBrandName.trim() + '_no_avatar_profile.jpg';
      } else {
        return config.apiUrl + '/' + config.altImg;
      }
    }
  }

  onImageError(e) {
    // Use asset URL with brand name for no_avatar image (matches backend pattern)
    const assetUrl = config.assetUrl;
    const assetBrandName = config.assetBrandName;
    let noAvatarUrl;
    if (assetUrl && assetBrandName && assetUrl.trim() !== '' && assetBrandName.trim() !== '') {
      noAvatarUrl = assetUrl.trim() + assetBrandName.trim() + '_no_avatar_profile.jpg';
    } else {
      noAvatarUrl = config.apiUrl + '/' + config.altImg;
    }
    if (e.target.getAttribute('src') !== noAvatarUrl) {
      e.target.setAttribute('src', noAvatarUrl);
    }
  }

  render() {
    const { permission } = this.props;
    let user;
    this.props?.user?.items && (user = this.props.user.items.data);

    var permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }
    if (this.state.redirect === '/resources') {
      return <Redirect to={'/resources/' + this.state.resource_id} />;
    }

    const authUser = this.props.user.profile?.data ?? {};
    const userData = this.props.user.items?.data ?? {};

    if (this.state.profile) {
      return (
        // details
        <div className='resource_container profile_container'>
          <ProfileHeader
          profile={this.state.profile}
          resourceId={this.state.resource_id}
          activeTab={this.state.tab}
          hash={this.state.hash}
          permList={permList}
          authUser={authUser}
          userData={userData}
          sendingDDForm={this.state.sendingDDForm}
          requestRehireDoc={this.state.request_rehire_doc}
          docRequest={this.state.doc_request}
          requestRehireDocStatus={this.state.request_rehire_doc_status}
          onToResourceList={this.toResourceList.bind(this)}
          onPrint={this.print.bind(this)}
          onMailSendOpen={this.mailSendOpenModal.bind(this)}
          onStatusOpen={this.statusOpenModal.bind(this)}
          onRemoveEmployee={this.handleRemoveEmployee.bind(this)}
          onDdFormConfirmOpen={this.openDdformConfirmModal.bind(this)}
          onDocumentRequest={this.documentRequest.bind(this)}
          onDownloadAllDocuments={this.downloadAllDocuments.bind(this)}
          onDownloadAllDocumentsAsPDF={this.downloadAllDocumentsAsPDF.bind(this)}
          onDocRequestModalClose={this.docRequestModalClose.bind(this)}
        />
          <TabNavigation
            activeTab={this.state.tab}
            permList={permList}
            hasApplicantHash={!!this.state.profile?.applicant_hash}
            onChangeTab={this.changeTab.bind(this)}
          />
          <TabContent
            activeTab={this.state.tab}
            hash={this.state.hash}
            permList={permList}
            reloadKey={this.state.reloadKey}
            authUser={this.props?.user?.profile?.data || {}}
            userData={this.props?.user?.items?.data}
            applnType={this.state.applnType}
            email={this.state.email}
            onSendMail={this.sendMail}
            onViewHistory={this.viewHistory.bind(this)}
            onViewDetails={this.viewDetails}
            onGoBack={() => this.props.goBack()}
          />

          {/* Status modal */}
          <NewModal
            id='status_popup'
            classNames={{ modal: 'status_popup' }}
            open={this.state.statusOpen}
            onClose={this.statusCloseModal.bind(this)}
            overlayClassName='empStatusPopup resEmpStatusPop profileEmp_status_modal'
            className='status_popup'
            center
          >
            <div id='statusPopup'>
              <div className='modal-head'>
                <h4 className='modal-title'>Current Status</h4>
              </div>
              {this.state.statusStep === '1' && (
                <div className='modal-body'>
                  <div className='status_step step1'>
                    <label>
                      {this.state.profile.first_name +
                        ' ' +
                        this.state.profile.last_name +
                        ' is: '}
                      <span className='green'>{this.state.status}</span>
                    </label>
                    <br />
                    <div className='user-status-edit-wrapper'>
                      <div>
                        {this.state.is_locked === 0 && (
                          <button
                            className='button'
                            onClick={this.handleLockProfile.bind(this)}
                          >
                            Lock Profile
                          </button>
                        )}
                        {this.state.is_locked === 1 && (
                          <button
                            className='button'
                            onClick={this.setStep.bind(this, '1a')}
                          >
                            Unlock Profile
                          </button>
                        )}
                      </div>
                      <div>
                        <button
                          className={`button outlined ${
                            this.state.is_locked === 1 ? 'disabled' : ''
                          }`}
                          onClick={this.setStep.bind(this, '2')}
                          disabled={this.state.is_locked === 1}
                        >
                          {this.state.status === 'Available'
                            ? 'Make Unavailable'
                            : 'Make Available'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {this.state.statusStep === '1a' && (
                <div className='modal-body'>
                  <div className='status_step step1'>
                    <section className='d-flex flex-column checkb'>
                      <h6 className='text-bold'>
                        Are you sure you want to Unlock the selected employee
                      </h6>

                      {(user.docs_status === -1 ||
                        user.rehire_docs_status === -1) && (
                        <label>
                          <input
                            type='checkbox'
                            onChange={this.requireDocs}
                            defaultChecked={this.state.requireDocs}
                          />
                          <span>Ask to fill Documents</span>
                        </label>
                      )}
                    </section>
                    <div className='user-status-edit-wrapper'>
                      <div>
                        <button
                          disabled={this.state.loader}
                          className='button disabled'
                          onClick={this.setStep.bind(this, '2')}
                        >
                          Cancel
                        </button>
                      </div>
                      <div>
                        <button
                          disabled={this.state.loader}
                          className='button'
                          onClick={this.unlockProfile}
                        >
                          Unlock
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {this.state.statusStep === '1b' && (
                <div className='modal-body'>
                  <div className='status_step step1'>
                    <section className='d-flex flex-column checkb'>
                      <p>
                        Are you sure you want to Lock the selected employee ?
                      </p>
                    </section>
                    <div className='user-status-edit-wrapper'>
                      <div>
                        <button
                          className='button grey'
                          onClick={this.setStep.bind(this, '2')}
                        >
                          Cancel
                        </button>
                      </div>
                      <div>
                        <button
                          className='button'
                          onClick={this.setStep.bind(this, '1c')}
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {this.state.statusStep === '1c' && (
                <div className='modal-body'>
                  <div className='status_step step1'>
                    <section className='d-flex flex-column checkb'>
                      <div classNames='full-width'>
                        <p>Last Day Worked</p>
                        <DatePicker
                          className='lastDayWorked'
                          name='lastDayWorked'
                          selected={this.state.lastDayWorked}
                          onChange={this.handleLastDayChange.bind(this)}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode='select'
                        />
                        <textarea
                          rows='3'
                          maxLength={1200}
                          className='lastDayReason'
                          value={this.state.lastDayReason}
                          name='lastDayReason'
                          onChange={this.changeLastDayReason}
                          errors={this.state.lastDayReasonErr}
                        />
                      </div>
                    </section>
                    <div className='user-status-edit-wrapper'>
                      <div>
                        <button
                          disabled={this.state.loader}
                          className='button grey'
                          onClick={this.setStep.bind(this, '2')}
                        >
                          Cancel
                        </button>
                      </div>
                      <div>
                        <button
                          disabled={this.state.loader}
                          className='button'
                          onClick={this.lockProfile}
                        >
                          Lock
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {this.state.statusStep === '2' && this.state.available && (
                <div className='modal-body'>
                  <div className='status_step step2'>
                    <label>Reason for Unavailability: </label>
                    <select
                      name='unavailableReason'
                      className='unavailability_reason'
                      value={this.state.unavailableReason}
                      onChange={this.changeUnavailabilityReason}
                      errors={this.state.unavailableErr}
                    >
                      <option value='0'>-- Select Reason --</option>
                      <option value='1'>Time Off</option>
                      <option value='2'>Sick</option>
                      <option value='3'>Injury</option>
                      <option value='4'>Other</option>
                    </select>
                    {(this.state.unavailableReason === '1' ||
                      this.state.unavailableReason === '2' ||
                      this.state.unavailableReason === '3' ||
                      this.state.unavailableReason === '4') && (
                      <div classNames='full-width'>
                        <textarea
                          rows='3'
                          maxLength={1200}
                          className='other_reason'
                          value={this.state.otherReason}
                          name='otherReason'
                          onChange={this.changeUnavailabilityReason}
                          errors={this.state.unavailableDescriptionErr}
                        />
                      </div>
                    )}
                    <label>
                      Do you know when {this.state.userName} will return?
                    </label>
                    <button
                      className='button'
                      onClick={this.setStatusReturn.bind(this, true)}
                    >
                      Yes
                    </button>
                    <button
                      className='button grey'
                      onClick={this.setStatusReturn.bind(this, false)}
                    >
                      No
                    </button>
                    <p className='step_no'>2/3</p>
                  </div>
                </div>
              )}
              {this.state.statusStep === '2' && !this.state.available && (
                <div className='modal-body'>
                  <div className='status_step step2'>
                    <label>
                      Are you sure you want to make the employee available?
                    </label>
                    <button
                      disabled={this.state.loader}
                      className='button'
                      onClick={this.changeStatus.bind(this, true)}
                    >
                      Yes
                    </button>
                    <button
                      disabled={this.state.loader}
                      className='button grey'
                      onClick={this.statusCloseModal.bind(this)}
                    >
                      No
                    </button>
                    <p className='step_no'>2/2</p>
                  </div>
                </div>
              )}
              {this.state.statusStep === '2a' && (
                <div className='modal-body'>
                  <div className='status_step step4'>
                    <label>Choose date of return:</label>
                    <DatePicker
                      className='returnDateField'
                      name='returnDateField'
                      selected={this.state.returnDateField}
                      onChange={this.handleDateChange.bind(this)}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode='select'
                      minDate={moment()}
                    />
                    <button
                      className='button btn_margin'
                      onClick={this.setStep.bind(this, '3')}
                    >
                      Next
                    </button>
                    <p className='step_no'>2/3</p>
                  </div>
                </div>
              )}
              {this.state.statusStep === '2b' && (
                <div className='modal-body'>
                  <div className='status_step step2'>
                    <label>
                      Are you sure you want to make the employee unavailable?
                    </label>
                    <button
                      disabled={this.state.loader}
                      className='button'
                      onClick={this.changeStatus.bind(this, true)}
                    >
                      Yes
                    </button>
                    <button
                      disabled={this.state.loader}
                      className='button grey'
                      onClick={this.statusCloseModal.bind(this)}
                    >
                      No
                    </button>
                    <p className='step_no'>3/3</p>
                  </div>
                </div>
              )}
              {this.state.statusStep === '3' && (
                <div className='modal-body'>
                  <div className='status_step step5'>
                    <label>
                      Are you sure you want to switch {this.state.userName} to
                      Unavailable?
                    </label>
                    <p>
                      (returning{' '}
                      {this.state.returnDate === ''
                        ? moment().format('MM/DD/YYYY')
                        : formatDate(this.state.returnDate)}
                      )
                    </p>
                    <button
                      className='button'
                      onClick={this.changeStatus.bind(this, true)}
                    >
                      Yes
                    </button>
                    <button
                      className='button grey'
                      onClick={this.statusCloseModal.bind(this)}
                    >
                      No
                    </button>
                    <p>Time off must be approved by your supervisor.</p>
                    <p className='step_no'>3/3</p>
                  </div>
                </div>
              )}
            </div>
          </NewModal>

          {/* uers upate success modal */}
          <ReactModal
            isOpen={this.state.alertOpen}
            onClose={this.alertCloseModal.bind(this)}
            contentLabel='Minimal Modal Example'
            overlayClassName='alertPopup'
          >
            <div id='statusPopup' className='popupModal'>
              <div className='modal-head'>
                <h4 className='modal-title'>{this.state.alertHead}</h4>
              </div>
              <div className='modal-body'>
                <p>{this.state.alertMsg}</p>
                <div className='btn_list'>
                  <button
                    className='button'
                    onClick={this.alertCloseModal.bind(this)}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </ReactModal>
          <InventoryAlertModal
            isOpen={this.state.inventoryUserAlert}
            onClose={() => this.setState({ inventoryUserAlert: false })}
            action={this.state.inventoryAlertAction || 'remove'}
            userHash={this.state.hash}
          />

          <NewModal
            id='remove_popup'
            className='status_popup'
            open={this.state.removeOpen}
            onClose={this.removeCloseModal.bind(this)}
            little
          >
            <div id='removePopup'>
              <div className='modal-head'>
                <h4 className='modal-title'>
                  Remove Employee:{' '}
                  {this.state.profile
                    ? this.state.profile.first_name +
                      ' ' +
                      this.state.profile.last_name
                    : ''}
                </h4>
              </div>
              <div className='modal-body'>
                {this.state.archiveStep == '3a' && (
                  <div>
                    <label>
                      Are you sure you want to archive this employee?
                    </label>
                    <br />
                    <button
                      className='button grey'
                      onClick={this.removeCloseModal.bind(this)}
                    >
                      Cancel
                    </button>
                    <button
                      className='button'
                      onClick={this.collectLastDayWorked.bind(this)}
                    >
                      Archive
                    </button>
                  </div>
                )}

                {this.state.archiveStep == '3b' && (
                  <div className='status_step step1'>
                    <section
                      className='d-flex flex-column checkb'
                      style={{ padding: '10px' }}
                    >
                      <div classNames='full-width'>
                        <p>Last Day Worked</p>
                        <DatePicker
                          className='lastDayWorked'
                          name='lastDayWorked'
                          selected={this.state.lastDayWorked}
                          onChange={this.handleLastDayChange.bind(this)}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode='select'
                        />
                        <textarea
                          rows='3'
                          maxLength={1200}
                          className='lastDayReason'
                          value={this.state.lastDayReason}
                          name='lastDayReason'
                          onChange={this.changeLastDayReason}
                          errors={this.state.lastDayReasonErr}
                        />
                      </div>
                    </section>
                    <div className='user-status-edit-wrapper'>
                      <div>
                        <button
                          disabled={this.state.loader}
                          className='button grey'
                          onClick={this.removeCloseModal.bind(this)}
                        >
                          Cancel
                        </button>
                      </div>
                      <div>
                        <button
                          disabled={this.state.loader}
                          className='button'
                          onClick={this.remove}
                        >
                          Ok
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </NewModal>

          <Modal
            id='remove_popup'
            className='status_popup'
            open={this.state.send_dd_form_confirm}
            onClose={this.ddFormConfirmCloseModal.bind(this)}
            little
          >
            <div id='removePopup'>
              <div className='modal-head'>
                <h4 className='modal-title'>Direct Deposit Form</h4>
              </div>
              <div className='modal-body'>
                <label>
                  This will send an email to{' '}
                  {this.state.profile
                    ? this.state.profile.first_name +
                      ' ' +
                      this.state.profile.last_name
                    : 'this employee'}
                  , with Direct Deposit form link.
                </label>
                <br />
                <button
                  className='button grey'
                  onClick={this.ddFormConfirmCloseModal.bind(this)}
                >
                  Cancel
                </button>
                <button className='button' onClick={this.sendDDForm.bind(this)}>
                  Send
                </button>
              </div>
            </div>
          </Modal>

          <Modal
            id='email_popup'
            className='status_popup'
            open={this.state.mailSendOpen}
            onClose={this.mailSendCloseModal.bind(this)}
            little
          >
            <div id='emailPopup'>
              <div className='modal-head'>
                <h4 className='modal-title'>Custom Message</h4>
              </div>
              <div className='modal-body'>
                <textarea
                  name='message'
                  cols='80'
                  rows='10'
                  value={this.state.message}
                  onChange={this.handleChange.bind(this)}
                />

                <p className='step_no'>
                  Signature will automatically be included.
                </p>

                <button
                  className='button grey'
                  onClick={this.mailSendCloseModal.bind(this)}
                >
                  Cancel
                </button>
                <button
                  className='button'
                  onClick={this.sendMail.bind(this, this.state.hash)}
                >
                  Send
                </button>
              </div>
            </div>
          </Modal>
          {this.state.alertPop && (
            <AlertPopup
              head={this.state.alertHead}
              message={this.state.alertMsg}
              alertFunction={this.state.alertFunction}
              close={this.closeAlert.bind(this)}
            />
          )}
        </div>
      );
    }
    return (
      <div className='resource_container profile_container'>
        <div className='page_title float'>
          <h1>
            {this.state.profile
              ? this.state.profile.first_name +
                ' ' +
                this.state.profile.last_name
              : ''}
          </h1>
          <div className='btn_list'>
            {permList.includes('Manage Passwords') && (
              <ChangePassword
                userType='user'
                user={user}
                isAdmin={
                  this.props?.user?.profile?.data?.is_admin !== 0 ? true : false
                }
              />
            )}
            <button className='button print' onClick={this.print.bind(this)}>
              Print
            </button>
            {permList.includes('Message Employees') && (
              <button
                className='button edit_resource'
                onClick={this.mailSendOpenModal.bind(this)}
              >
                Message
              </button>
            )}
            {permList.includes('Status Update') && (
              <button
                className='button edit_resource'
                onClick={this.statusOpenModal.bind(this)}
              >
                Edit Status
              </button>
            )}
            {permList.includes('Remove Employee') && (
              <button
                className='button edit_resource'
                onClick={this.handleRemoveEmployee.bind(this)}
              >
                Remove Employee
              </button>
            )}
          </div>
        </div>
        <div className='applicants_inner_head inner_head' />
        <div className='settings'>
          <center
            id='feedLoader'
            className={this.state.loader ? this.state.loader : ''}
          >
            <img
              alt='Loader'
              src={require('../assets/images/loader.gif').default}
            />
          </center>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user, permission, inventory, chat } = state;
  return {
    user,
    permission,
    inventory,
    chat,
  };
}

const connectedRegisterPage = connect(mapStateToProps)(Profile);
export { connectedRegisterPage as Profile };

Profile.propTypes = {
  match: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  resourceDetails: PropTypes.object,
  user: PropTypes.object,
  data: PropTypes.array.isRequired,
  permission: PropTypes.object,
  props: PropTypes.any,
  history: PropTypes.object,
  inventory: PropTypes.object,
  chat: PropTypes.object.isRequired,
  hash: PropTypes.string.isRequired,
  goBack: PropTypes.func.isRequired,
  editProfile: PropTypes.func.isRequired,
  status: PropTypes.string,
};
